const CONSENT_KEY = 'analytics_consent';

export type ConsentState = 'granted' | 'denied' | 'pending';

export function getConsent(): ConsentState {
  const v = localStorage.getItem(CONSENT_KEY);
  if (v === 'granted' || v === 'denied') return v;
  return 'pending';
}

export function setConsent(state: 'granted' | 'denied'): void {
  localStorage.setItem(CONSENT_KEY, state);
}
